var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:`text-decoration-underline text-capitalize ${_vm.margin0 ? '' : 'custom-text-button'} ${this.noMargin ? '' : ' mt-3'}`,attrs:{"color":this.color,"text":""},on:{"click":function($event){return _vm.callAction()}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }